interface MiniBarsDatum {
  label: string;
  value: number;
}

interface MiniBarsProps {
  data: MiniBarsDatum[];
  /** Prefixed to each value label, e.g. "$". */
  prefix?: string;
  /** Suffixed to each value label, e.g. "M". */
  unit?: string;
}

/**
 * A small column chart on the sequential teal ramp. Hand-rolled (no chart lib) so
 * the bars read cleanly at any width. Gold is never a data-field color; seq tints
 * are applied inline because the index is computed at runtime.
 */
const seq = (i: number) => `hsl(var(--chart-seq-${Math.min(5, 2 + i)}))`;

const MiniBars = ({ data, prefix = "", unit = "" }: MiniBarsProps) => {
  const max = Math.max(...data.map((d) => d.value), 0) || 1;
  return (
    <div className="flex h-[130px] items-end gap-3.5 px-1">
      {data.map((d, i) => (
        <div key={i} className="flex h-full flex-1 flex-col items-center justify-end gap-2">
          <span className="text-xs font-semibold tabular-nums text-ink-700">
            {prefix}
            {d.value}
            {unit}
          </span>
          <div
            className="w-full max-w-[46px] rounded-t-[5px]"
            style={{ height: `${(d.value / max) * 100}%`, minHeight: 4, background: seq(i) }}
          />
          <span className="text-[11.5px] font-medium text-ink-500">{d.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MiniBars;
